var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82432 6.96015H10.2385V5.87971C10.2385 4.84549 11.0735 4.00553 12.107 4.00003C13.1112 3.99465 13.9296 4.80496 13.935 5.80986C13.9351 5.82636 13.9349 5.84285 13.9346 5.85934L13.9105 6.96013H16.2511C17.2587 6.96013 18.0755 7.77747 18.0755 8.78566V11.203H19.2015C20.1948 11.203 21 12.0087 21 13.0027C21 13.9967 20.1948 14.8025 19.2015 14.8025H18.0754V17.1745C18.0754 18.1827 17.2587 19 16.2511 19H13.9755V17.8537C13.9755 16.7742 13.1009 15.899 12.0221 15.899C10.9433 15.899 10.0688 16.7742 10.0688 17.8537V19H7.82432C6.81679 19 6 18.1827 6 17.1745V14.863H7.26874C8.33401 14.863 9.19756 13.9989 9.19756 12.9329C9.19756 11.867 8.33401 11.0028 7.26876 11.0028H6V8.78568C6 7.77746 6.81679 6.96015 7.82432 6.96015Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdkIcon);
export default __webpack_public_path__ + "static/media/sdkIcon.02116d5631ba3cc2527bd909fac680bc.svg";
export { ForwardRef as ReactComponent };